import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { queueRuleSchema } from '../models/queueRule.schema';
import { ruleListQuerySchema } from './list.schema';

export type RuleListQuery = PaginationQuery & {
  schema?: ID;
  queue?: ID | ID[];
  enabled?: string;
  linked?: string;
  actions?: string | string[];
};

export const list = (query: RuleListQuery) => {
  return {
    endpoint: `/rules`,
    method: 'GET',
    responseSchema: listResponse(queueRuleSchema),
    query: { ...query, includeTotal: true },
    querySchema: ruleListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
